<template>
  <input
    :style="{ fontFamily: currentFont.css }"
    class="font-preview"
    :class="{ 'empty': !fontPreviewHasInput, 'has-input': fontPreviewHasInput }"
    :placeholder="placeholder"
    @input="_onInput"
    maxlength="20"
    autocomplete="off"
    autocorrect="off"
    autocapitalize="off"
    spellcheck="false"
    autofocus
  />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'app',
  data() {
    return {
      placeholder: '',
    }
  },
  mounted() {
    this._animatePlaceholder();
  },
  computed: {
    ...mapState('ui', [
      'fontPreviewHasInput'
    ]),
    ...mapState('font', [
      'currentFont'
    ])
  },
  methods: {
    ...mapActions('ui', [
      'setFontPreviewState'
    ]),
    _animatePlaceholder() {
      const placeholder = "Type something...";
      let i = 0;
      const interval = setInterval(() => {
        if (i < placeholder.length) {
          this.placeholder += (placeholder.charAt(i));
          i++;
        } else {
          clearInterval(interval);
        }
      }, 100)
    },
    _onInput(e) {
      this.setFontPreviewState(e.target.value.length > 0);
    },
  }
}
</script>

<style lang="scss">
  .font-preview {
    font-size: 6.875vw;
    white-space: nowrap;
    overflow: hidden;
    background: inherit;
    outline: none;
    border: none;
    padding: 0;
    -webkit-appearance: none;
    transition: transform 500ms ease-in-out;  

    @media (max-width: 40rem) {
      font-size: 10.5vw;
    }

    .app.dark & {
      color: #fff;
    }

    &::placeholder {
      color: #e0e0e0;
      font-family: 'neue-haas-grotesk-text';

      .app.dark & {
        color: #1C1C1E;
      }
    }

    &.empty {
      width: 55vw;
      text-align: left;

      @media (max-width: 40rem) { 
        width: 84.25vw;
      }
    }

    &.has-input {
      width: 100%;
      text-align: center;
      transform: translateY(-5vh);
    }
  }
</style>
